import { Molecule, wrap } from 'AppReact';
import styled, { css } from 'styled-components';
import { Label } from './atoms';
import {RightLabelMargin, LeftLabelMargin} from './wrappers'
import { Switch } from "atoms";

const template = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    color: ${theme?.colour?.secondary};
  `}
`;

export default Molecule({
  template,
  atoms: [
    {
      component: wrap(Label, RightLabelMargin),
      renderIf:({labeledDirection}) => labeledDirection != 'right',
      name: 'Label',
      displayValue: ({ label }) => label ?? 'Active: ',
    },
    {
      component: Switch,
      name: 'Toggle',
    },
    {
      component: wrap(Label, LeftLabelMargin),
      renderIf:({labeledDirection}) => labeledDirection == 'right',
      name: 'Label',
      displayValue: ({ label }) => label ?? 'Active: ',
    },
  ]
})